import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import CommonModal from "PhishingManager/components/Modal";
import { ResetMFARequest } from "Services/Api/Users/Types";
import { RESET_MFA } from "Services/Api/Users/Mutations";
import { useMutation } from "@apollo/client";
import { EditUserValues } from "Pages/User/User.types";
import { useDashboardContext } from "Pages/Dashboard/DashboardContext";
import { useState } from "react";

const EnableMFAModal = ({ onClose } : { onClose: () => void }) => {
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
	const [resetMFAMutation] = useMutation<unknown, ResetMFARequest>(RESET_MFA);
	const { values } = useFormikContext();
    const { setToastInfo } = useDashboardContext();

    const handleSubmit = async () => {
        const editUserValues = values as EditUserValues;
        try {
            if(!editUserValues.peakV3Id) return;
            setLoading(true);
            await resetMFAMutation({
                variables: { input: { peakV3Id: editUserValues.peakV3Id } }
            });
            onClose();
        } catch (e) {
			setToastInfo?.({ message: t(`errorCodes.genericErrorMessage`), type: 'warning' });
        } finally {
            setLoading(false);
        }
    }

    return <CommonModal
        visible
        modalTitle={t(`profile.mfa.modalTitle`)}
        confirmText={t('profile.mfa.btnText')}
        cancelText={t('cancel')}
        iconType={null}
        confirmBtnDisabled={loading}
        showConfirmBtn={true}
        onClose={onClose}
        onConfirm={handleSubmit}
        modalContentDesc={[t('profile.mfa.modalDesc')]} />
}

export default EnableMFAModal;